import { useMemo } from 'react';
import { trpc } from '@/lib/trpc';
import { NewQuizModal } from '@/components/quiz/NewQuizModal';
import { QuizCard } from '@/components/quiz/QuizCard';

export function QuizzesScreen() {
  const { data, isLoading } = trpc.admin.quiz.getQuizzes.useQuery();

  const quizzes = useMemo(() => {
    return data?.quizzes || [];
  }, [data?.quizzes]);

  return (
    <div className="flex-1">

      {/* Page Header */}
      <div>

        <div className="flex justify-end items-center">
            <NewQuizModal />
        </div>
      </div>

      {/* Content */}
      <div className="mt-4">
        {isLoading ? (
          <div className="bg-white rounded-lg shadow p-12 text-center">
            <p className="text-gray-500">Loading quizzes...</p>
          </div>
        ) : (
          <>
            {/* Quiz Cards Grid */}
            <div className="flex flex-wrap gap-6">
              {quizzes.map((quiz) => (
                <QuizCard key={quiz._id} quiz={quiz} />
              ))}
            </div>

            {/* Empty State */}
            {quizzes.length === 0 && (
              <div className="p-12 text-center">
                <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2">
                  No Quizzes Found
                </h3>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
